const path = "/rh/lancamento-banco-horas";
const bancoHoras = {
  main: path,
  saldoTotal: `${path}/saldo-total`,
};

export default bancoHoras;
